/* Pandalino — Product Installments (JS) — versión visible desde el inicio */
(function () {
  "use strict";

  // ===== Utils ===========================================================
  function formatMoney(cents, format) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === "function") {
        return Shopify.formatMoney(cents, format);
      }
    } catch (e) {}
    var fmt = format || "${{amount_no_decimals}}";
    var value = Math.max(0, cents || 0) / 100;

    var n2 = value.toFixed(2);
    var n0 = Math.round(value).toString();
    var n2_th = Number(n2).toLocaleString("es-CL", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var n0_th = Number(n0).toLocaleString("es-CL");

    var with_comma   = n2_th;                                   // 1.234,50
    var no_dec_comma = n0_th;                                   // 1.235
    var with_dot     = n2.replace(/\B(?=(\d{3})+(?!\d))/g, ",");   // 1,234.50
    var no_dec_dot   = n0.replace(/\B(?=(\d{3})+(?!\d))/g, ",");   // 1,235

    return fmt
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, no_dec_comma)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, with_comma)
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, no_dec_dot.replace(/,/g, " "))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, with_dot.replace(/,/g, " "))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, n0_th)
      .replace(/\{\{\s*amount\s*\}\}/g, n2_th)
      .replace(/\{\{\s*[^}]*amount[^}]*\}\}/g, n0_th); // catch‑all
  }
  function getRoundingFn(mode) { if (mode==="ceil") return Math.ceil; if (mode==="floor") return Math.floor; return Math.round; }
  function toInt(v, fb) { var n = parseInt(v, 10); return isNaN(n) ? (fb || 0) : n; }

  // ===== Core per widget ================================================
  function initOne(el) {
    try {
      if (!el || el.__pandalinoInit) return;
      el.__pandalinoInit = true;

      // Config del DOM
      var moneyFormat = el.dataset.moneyFormat || "${{amount_no_decimals}}";
      var roundingMode = el.dataset.rounding || "round";
      var defaultN = Math.max(1, toInt(el.dataset.default, 3));
      var showBadge = (el.dataset.showBadge + "") === "true";
      var twelveMin = Math.max(0, toInt(el.dataset.twelveMin, 0)); // CLP, no centavos

      // Nodos
      var pills = el.querySelectorAll(".Installments__pill");
      var resultWrap = el.querySelector(".Installments__result");
      var resultCount = el.querySelector(".Installments__result-count");
      var resultValue = el.querySelector(".Installments__result-value");
      var compareWrap = el.querySelector(".Installments__badge");
      var compareVal  = compareWrap ? compareWrap.querySelector(".Installments__compare") : null;

      // Estado de variant/precio
      var lastVariant = {
        price: toInt(el.dataset.initialPrice, 0),                  // en centavos
        compare_at_price: toInt(el.dataset.initialCompare, 0)      // en centavos
      };

      function displayPriceCents() { return lastVariant.price || 0; }
      function hasDiscount() { return (lastVariant.compare_at_price || 0) > (lastVariant.price || 0); }

      function updateBadge() {
        if (!showBadge || !compareWrap || !compareVal) return;
        if (hasDiscount()) {
          compareWrap.hidden = false;
          compareVal.textContent = formatMoney(lastVariant.compare_at_price, moneyFormat);
        } else {
          compareWrap.hidden = true;
        }
      }

      function update(n) {
        n = Math.max(1, toInt(n, defaultN));
        if (resultCount) resultCount.textContent = n;
        var cents = displayPriceCents();
        var per = cents ? getRoundingFn(roundingMode)(cents / n) : 0;
        if (resultValue) resultValue.textContent = formatMoney(per, moneyFormat);
        updateBadge();
      }

      // Regla opcional: ocultar 12x si el precio < twelveMin
      function enforceInstallmentRules() {
        if (!twelveMin) return;
        var priceCents = displayPriceCents();
        var allow12 = priceCents >= (twelveMin * 100);
        var pill12 = el.querySelector('.Installments__pill[data-installments="12"]');
        if (!pill12) return;

        pill12.style.display = allow12 ? "" : "none";

        // Si 12x estaba activa y ahora se oculta, elegir otra visible y actualizar
        if (!allow12 && pill12.classList.contains("is-active")) {
          var visibles = Array.from(el.querySelectorAll(".Installments__pill"))
            .filter(function (p) { return p.style.display !== "none"; });
          var fallback = visibles[visibles.length - 1] || visibles[0];
          if (fallback) {
            visibles.forEach(function(b){ b.classList.remove("is-active"); b.setAttribute("aria-checked","false"); });
            fallback.classList.add("is-active"); fallback.setAttribute("aria-checked","true");
            update(fallback.dataset.installments);
          }
        }
      }

      // Click en opciones → activa y calcula
      pills.forEach(function (btn) {
        btn.addEventListener("click", function () {
          pills.forEach(function (b) { b.classList.remove("is-active"); b.setAttribute("aria-checked","false"); });
          btn.classList.add("is-active"); btn.setAttribute("aria-checked","true");
          update(btn.dataset.installments);
        });
      });

      // INIT: usa la pill marcada como activa o el default
      var start = el.querySelector(".Installments__pill.is-active") || pills[0];
      update(start ? start.dataset.installments : defaultN);
      enforceInstallmentRules();

      // Cambios de variante → recalcular manteniendo la opción activa
      function onVariantChange(e) {
        var v = e && e.detail ? e.detail.variant : null;
        if (v && typeof v.price === "number") {
          lastVariant.price = v.price;
          lastVariant.compare_at_price = (typeof v.compare_at_price === "number") ? v.compare_at_price : 0;
          enforceInstallmentRules();
          var current = el.querySelector(".Installments__pill.is-active") || el.querySelector(".Installments__pill");
          update(current ? current.dataset.installments : defaultN);
        }
      }
      document.addEventListener("variant:change", onVariantChange);
      document.addEventListener("product:variant-change", onVariantChange);

    } catch (err) {
      console && console.warn && console.warn("Installments init error:", err);
    }
  }

  // ===== Bootstrapping global ===========================================
  function initAll() {
    document.querySelectorAll('.Installments[data-initial-price]').forEach(initOne);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();
  window.addEventListener("load", initAll);
  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:block:load", initAll);
  new MutationObserver(function(){ initAll(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
